import { render, staticRenderFns } from "./SingleArticleOverview.vue?vue&type=template&id=75f7d49d"
import script from "./SingleArticleOverview.vue?vue&type=script&lang=ts"
export * from "./SingleArticleOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports